<template>
<!-- <v-app class="body_main_container"> -->
  <div class="main_container1">
    <Header></Header>
    <div class="body_container">
      <div class="sidebar_container" v-if="toggle" :class="smallScreen ? 'sidebar_mobile' : '' ">
        <Sidebar></Sidebar>
      </div>
      <div class="route_view_container">
        <router-view></router-view>
      </div>
    </div>
  </div>
<!-- </v-app> -->
</template>

<script>
import Sidebar from "@/components/Sidebar";
import Header from "@/components/Header";
import {mapGetters} from 'vuex';
export default {
  name: 'App',
  data() {
    return {
      smallScreen: false,
    }
  },
  components: {
    Sidebar,
    Header,
  },
  async created() {
    await this.$store.dispatch("getConsultancies");
  },
  mounted() {
    window.addEventListener('resize',this.screenWidth);
     this.screenWidth();
  },
  computed: {
    ...mapGetters(['isLoggedIn', 'toggle']),    
  },
  methods: {
    screenWidth() {
      let screenWidth = (window.innerWidth > 0) ? window.innerWidth : screen.width;
      if(screenWidth < 700) {
        this.$store.commit('NAVBAR', false);
        this.smallScreen = true;      
      } else {
        this.$store.commit('NAVBAR', true); 
        this.smallScreen = false;  
      }
    }
  },
  destroyed(){
    window.removeEventListener('resize',this.screenWidth);
  }
};
</script>

<style lang="sass">
@import './scss/main';

</style>



// WEBPACK FOOTER //
// src/App.vue